import { createDom } from 'xgplayer/src/utils/util';
import Loading from '../assets/play.svg';
import '../style/controls/loading.scss';

let s_loading = function() {
  let player = this;
  let root = player.root;
  let container = createDom(
    'xg-loading',
    `
  <div class="xg-loading-icon">
    ${Loading}${Loading}${Loading}
  </div>
  <div class="xg-loading-text">正在缓冲...</div>
  `,
    {},
    'xgplayer-loading'
  );
  player.once('ready', () => {
    root.appendChild(container);
  });
};

export default {
  name: 's_loading',
  method: s_loading
};
